import { List as ImmutableList, Record } from 'immutable';

export const POSTPONED_ACTIONS_REDUCER_KEY = 'postponedActionsStore';

export const mkPostponedActionsStore = Record({
  postponedActions: ImmutableList(),
});

export const mkPostponedAction = Record({
  key: undefined,
  action: null,
  onFailure: undefined,
  maxAttempts: undefined,
  error: undefined,
});
